module.exports = __webpack_public_path__ + "assets/img/ic-lock-red.5d04f32f.svg";